// src/components/ReservationList.jsx (pass edit/delete props to rows)

import React, { useMemo } from 'react';
import ReservationRow from './ReservationRow';

export default function ReservationList({
	reservations = [],
	loading = false,
	showPast = false,
	isEditMode = false,
	onUpdate,
	onDelete,
}) {
	const rows = useMemo(() => {
		const now = new Date();
		now.setHours(0, 0, 0, 0);

		const filtered = showPast
			? reservations
			: reservations.filter((r) => r?.endDate && new Date(r.endDate) > now);

		return filtered.sort(
			(a, b) => new Date(a.startDate) - new Date(b.startDate)
		);
	}, [reservations, showPast]);

	if (loading) return <div className='text-sm text-slate-600'>Loading…</div>;

	if (!rows.length) {
		return (
			<div className='rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-700'>
				{showPast ? 'No reservations yet.' : 'No upcoming reservations.'}
			</div>
		);
	}

	return (
		<div className='space-y-2 overflow-scroll max-h-[500px]'>
			{rows.map((r, i) => (
				<ReservationRow
					key={r.id || r._id || `${r.name}-${r.startDate}-${r.endDate}-${i}`}
					reservation={r}
					isEditMode={isEditMode}
					onUpdate={onUpdate}
					onDelete={onDelete}
				/>
			))}
		</div>
	);
}
